module.exports = __webpack_public_path__ + "img/indoor5.13dc1177.jpg";